var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnonyBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3342 7.29845C14.6846 4.20375 11.7699 2.31934 8.53186 2.29957C7.65022 2.29609 6.77364 2.4328 5.93493 2.70458L6.72716 3.51152C7.31523 3.36347 7.9194 3.28899 8.52582 3.28979C11.3133 3.3068 13.8387 4.87691 15.3328 7.50524C14.7724 8.47321 14.0329 9.32566 13.1538 10.0171L13.8525 10.7244C14.8708 9.91364 15.7184 8.90912 16.3462 7.76889L16.4764 7.53203L16.3342 7.29845Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80449 1.39201L3.99918 3.61366C2.59766 4.50347 1.44926 5.73964 0.664887 7.20278L0.534739 7.43469L0.662016 7.67313C2.3117 10.7678 5.22639 12.6522 8.46439 12.672C9.72828 12.68 10.9776 12.4015 12.1184 11.8575L14.5789 14.3482L15.4498 13.6108L2.65562 0.659467L1.80449 1.39201ZM5.88879 5.52648C5.4216 6.1769 5.19963 6.97165 5.26219 7.77002C5.32474 8.5684 5.66779 9.31888 6.23059 9.88859C6.79339 10.4583 7.53963 10.8105 8.33717 10.8828C9.13472 10.9551 9.93213 10.7428 10.5882 10.2836L11.3755 11.0806C10.4561 11.4671 9.46791 11.6632 8.47058 11.657C5.68313 11.64 3.15767 10.0699 1.66358 7.44158C2.39629 6.16293 3.4465 5.09495 4.71268 4.3409L5.88879 5.52648Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonyBlack);
export default __webpack_public_path__ + "static/media/anony_black.3b6bc565c2a64eeb3c085af5a3a13910.svg";
export { ForwardRef as ReactComponent };